export { default } from './ThanksForOrderingLink';
